import axios from "axios";
import moment from "moment";
import Cookies from "universal-cookie";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import {
  CameraOutlined,
  CloseCircleOutlined,
  DoubleRightOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Content, Footer, Header } from "antd/lib/layout/layout";

import {
  Avatar,
  Button,
  Col,
  Form,
  Image,
  Input,
  Layout,
  List,
  Modal,
  notification,
  Row,
  Space,
  Spin,
  Upload,
} from "antd";

import { authAxios } from "../utils";
import { logout } from "../store/actions/auth";
import { ItemRender } from "../components/ItemRender";
import { openNotificationWithIcon } from "./Function";
import { groupContractCode } from "../utils/groupContractCode";
import { changePass, logoutURL, updateAvatarURL } from "../constants";

const cookies = new Cookies();
const logo = `${process.env.PUBLIC_URL}/logo_new/Rainscales-logo-white.png`;

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const LogoImage = () => {
  return (
    <div className="logo_v2">
      <Image
        src={logo}
        preview={false}
        style={{
          objectFit: "cover",
          width: 180,
          height: 34,
        }}
      />
    </div>
  );
};

const messageBox = (type, title, contents) => {
  notification[type]({
    message: title,
    description: contents,
  });
};

const ModalChangePass = ({ visible, onCancel, userId }) => {
  const [loading, setLoading] = useState(false);
  const handleModalCancel = () => {
    setLoading(false);
    onCancel();
  };
  const logout_new = (e) => {
    authAxios(cookies.get("token"))
      .get(logoutURL)
      .then((res) => {
        window.location = "/login";
      });
    logout();
  };
  const fetchApiChangePass = (params = {}) => {
    setLoading(true);
    var FormData = require("form-data");
    var data = new FormData();
    data.append("user_id", userId);
    data.append("pass_old", params.pass_old);
    data.append("pass_new1", params.pass_new1);
    data.append("pass_new2", params.pass_new2);

    authAxios(cookies.get("token"))
      .post(changePass, data)
      .then((res) => {
        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => value,
          );
          messageBox("error", "Lỗi", dataError);
          setLoading(false);
          onCancel();
        } else {
          messageBox("success", "Thông báo", "Đổi mật khẩu thành công.");
          onCancel();
          logout_new();
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const onFinishChangePass = (values) => {
    if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()])[A-Za-z\d~`!@#$%^&*()]{9,}$/.test(
        values.passNew_1,
      ) == false
    ) {
      messageBox("error", "Lỗi", "Mật khẩu không hợp lệ.");
      return;
    } else {
      fetchApiChangePass({
        pass_old: values.passOLD,
        pass_new1: values.passNew_1,
        pass_new2: values.passNew_2,
      });
    }
  };
  return (
    <Modal
      destroyOnClose
      title="Đổi mật khẩu"
      open={visible}
      onCancel={handleModalCancel}
      footer={null}
      closeIcon={<CloseCircleOutlined title="Thoát (ESC)" />}
      keyboard
      width={650}
      className="change-pass"
    >
      <Form
        onFinish={(values) => onFinishChangePass(values)}
        validateMessages={validateMessages}
        layout="vertical"
      >
        <Row>
          <Col span={12} offset={6}>
            <Form.Item
              name="passOLD"
              rules={[
                {
                  required: true,
                },
              ]}
              label={"Nhập mật khẩu cũ"}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={6}>
            <Form.Item
              name="passNew_1"
              rules={[
                {
                  required: true,
                },
              ]}
              label={"Nhập mật khẩu mới"}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={6}>
            <Form.Item
              name="passNew_2"
              label={"Nhập lại mật khẩu mới"}
              dependencies={["passNew_1"]}
              hasFeedback
              rules={[
                {
                  required: true,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("passNew_1") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Hai mật khẩu bạn đã nhập không khớp!"),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ paddingBottom: "5px" }}>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              shape="round"
              size="default"
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Đổi mật khẩu
            </Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <h4 style={{ color: "#a91c1c" }}>Lưu ý: </h4>
        <h4 style={{ color: "#73879C" }}>
          &nbsp;Mật khẩu phải ít nhất 9 ký tự bao gồm chữ hoa, chữ thường, số và
          ký tự đặc biệt.
        </h4>
      </Row>
    </Modal>
  );
};

const ModalFormEditUser = ({ visible, onCancel, dataUserEdit }) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const [fileList, setFileList] = useState([]);

  const onFinish = () => {
    setLoadingModal(true);
    if (fileList.length != 0) {
      var FormData = require("form-data");
      var data = new FormData();
      if (fileList != undefined) {
        fileList.forEach((element) => {
          data.append("avatar", element.originFileObj);
        });
      }
      authAxios(cookies.get("token"))
        .post(updateAvatarURL, data)
        .then((res) => {
          if (res.data.error) {
            const dataError = Object.entries(res.data.error).map(
              ([key, value]) => <p>{value}</p>,
            );
            openNotificationWithIcon("error", "Lỗi", dataError);
            setLoadingModal(false);
          } else {
            onCancelModal(true);
            setLoadingModal(false);
          }
        })
        .catch((err) => {
          if (err.data) {
            const dataError = Object.entries(err.data).map(([key, value]) => (
              <p>{value}</p>
            ));
            openNotificationWithIcon("error", "Lỗi", dataError);
            setLoadingModal(false);
          }
        });
    } else {
      onCancelModal(true);
      setLoadingModal(false);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      msnv: dataUserEdit.msnv,
      tendangnhap: dataUserEdit.username,
      ten: dataUserEdit.first_name,
      ho: dataUserEdit.last_name,
      email: dataUserEdit.email,
      birthday:
        dataUserEdit.birthday != null
          ? moment(dataUserEdit.birthday)
          : dataUserEdit.birthday,
    });
    setFileList([]);
  }, [dataUserEdit]);

  const onOk = () => {
    setLoadingModal(true);
    onFinish();
  };

  const onCancelModal = (value, text) => {
    onCancel(value, text);
  };

  const handleUploadCancel = () => {
    setPreviewVisible(false);
  };

  const handleChangeUpload = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleUploadPreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    );
  };

  return (
    <Modal
      title="Cập nhật ảnh đại diện"
      open={visible}
      onOk={onOk}
      onCancel={onCancelModal}
      okText="Lưu"
      width={650}
      forceRender
      bodyStyle={{ paddingTop: "0px", maxHeight: "700px", overflowY: "auto" }}
      className="change-pass "
    >
      <Spin spinning={loadingModal}>
        <Row>
          <Col
            style={{
              display: "inline-flex",
              alignItems: "center",
              marginTop: "13px",
            }}
          >
            <span
              style={{
                cursor: "pointer",
                verticalAlign: "sub",
                marginLeft: "5px",
              }}
            >
              <Upload
                showUploadList={false}
                fileList={fileList}
                onChange={handleChangeUpload}
                beforeUpload={(file) => {
                  if (
                    file.type !== "image/png" &&
                    file.type !== "image/jpeg" &&
                    file.type !== "image/gif"
                  ) {
                    openNotificationWithIcon(
                      "error",
                      "Lỗi",
                      `Sai định dạng file. Chỉ chấp nhận: PNG, JPEG, GIF.`,
                    );
                    return Upload.LIST_IGNORE;
                  }
                  return false;
                }}
                style={{ verticalAlign: "sub" }}
                maxCount={1}
              >
                {dataUserEdit && dataUserEdit.avatar_url != "" ? (
                  <Avatar
                    src={
                      <Image
                        src={dataUserEdit.avatar_url}
                        fallback="data:image/png;base64,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"
                        style={{ width: "100%", minHeight: "100px" }}
                        preview={{
                          visible: false,
                          maskClassName: "customize-mask",
                          mask: (
                            <Space direction="horizontal" align="center">
                              <EditOutlined />
                              Đổi ảnh
                            </Space>
                          ),
                        }}
                      />
                    }
                    style={{
                      maxWidth: "150px",
                      maxHeight: "150px",
                      minWidth: "100px",
                      minHeight: "100px",
                    }}
                  />
                ) : (
                  <Avatar
                    icon={<CameraOutlined />}
                    style={{
                      width: "100px",
                      height: "100px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  />
                )}
              </Upload>
            </span>
            <Modal
              open={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={handleUploadCancel}
            >
              <img alt="example" style={{ width: "100%" }} src={previewImage} />
            </Modal>
            {fileList.length != 0 ? <DoubleRightOutlined /> : null}
            <Upload
              listType="picture"
              fileList={fileList}
              onPreview={handleUploadPreview}
              onChange={handleChangeUpload}
              beforeUpload={() => false}
              style={{
                maxWidth: "150px",
                maxHeight: "150px",
                minWidth: "70px",
                minHeight: "70px",
              }}
            ></Upload>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
};

export const HomePage = () => {
  const [lsMenu, setLsMenu] = useState(null);
  const [username, setUsername] = useState("");
  const [dataUserEdit, setdataUserEdit] = useState(null);
  const [modalVisibleInfoUser, setmodalVisibleInfoUser] = useState(false);
  const [isShowModalChangePass, setIsShowModalChangePass] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const userInfo = useSelector((state) => state.user);

  useEffect(() => {
    if (
      localStorage.getItem("menu") &&
      localStorage.getItem("menu").includes("homepage.rainscales.com.vn/ticket")
    ) {
      window.location.href = "/logout";
    }
  }, []);

  useEffect(() => {
    const menuFromStorage = localStorage.getItem("menu");
    if (!menuFromStorage) return;

    const rawMenu = JSON.parse(menuFromStorage);
    const newMenu = groupContractCode(rawMenu);

    setLsMenu(newMenu);
  }, [username]);

  const logout = () => {
    axios
      .get(logoutURL)
      .then((res) => {
        localStorage.clear();
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(
              /=.*/,
              "=;expires=" + new Date().toUTCString() + "; path=/",
            );
        });
        window.location.href = "/login";
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const hideEditUserModal = (value) => {
    setmodalVisibleInfoUser(false);
    if (value === true) {
      window.location.reload();
      openNotificationWithIcon(
        "success",
        "Thành công",
        "Cập nhật thông tin người",
      );
    }
  };

  useEffect(() => {
    if (userInfo.user) {
      setUsername(userInfo.user.username);
      setdataUserEdit(userInfo.user);
    }

    if (userInfo.permission) {
      setIsAdmin(userInfo.permission.view_user === true ? true : false);
    }
  }, [userInfo]);

  return (
    <Layout style={{ height: "100vh" }}>
      <Header style={{ width: "100%" }}>
        <div className="logo">
          <LogoImage />
        </div>

        <div className="btn-logout">
          <Button danger onClick={() => logout()}>
            Đăng xuất
          </Button>
        </div>
        <div className="btn-logout" style={{ marginRight: 10 }}>
          <Button type="default" onClick={() => setIsShowModalChangePass(true)}>
            Đổi mật khẩu
          </Button>
        </div>
        {isAdmin && (
          <div className="btn-logout" style={{ marginRight: 10 }}>
            <Button type="default" success>
              <Link to={"/settings/users"}>Quản lý user</Link>
            </Button>
          </div>
        )}
      </Header>
      <Content
        className="site-layout"
        style={{ minHeight: "77vh", padding: "0 16px" }}
      >
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <h1 style={{ fontSize: 50, color: "#fff" }}>Xin chào {username}</h1>
          </Col>
        </Row>
        <div
          style={{
            maxWidth: 1200,
            margin: "auto",
          }}
        >
          <Row>
            {lsMenu ? (
              <List
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 3,
                  xl: 3,
                  xxl: 3,
                }}
                style={{ width: "100%" }}
                dataSource={lsMenu}
                locale={{ emptyText: " " }}
                renderItem={(item) => (
                  <List.Item>
                    <ItemRender item={item} />
                  </List.Item>
                )}
              />
            ) : null}
          </Row>
        </div>
      </Content>
      <Footer style={{ textAlign: "center", color: "#fff" }}>
        RAINSCALES ©{new Date().getFullYear()}
      </Footer>
      {dataUserEdit && (
        <ModalFormEditUser
          visible={modalVisibleInfoUser}
          onCancel={hideEditUserModal}
          dataUserEdit={dataUserEdit}
        />
      )}
      {dataUserEdit && (
        <ModalChangePass
          visible={isShowModalChangePass}
          onCancel={() => setIsShowModalChangePass(false)}
          userId={dataUserEdit.userId}
        />
      )}
    </Layout>
  );
};
